module.exports = __webpack_public_path__ + "img/torindrive.45c55d6f.png";